module.exports = __webpack_public_path__ + "static/media/hab2-1.12ffc934.jpg";